/* eslint-disable camelcase */
export enum FollowupTypes {
  GET_FOLLOWUPS_REQUEST = '@followupOnlineSearch/GET_FOLLOWUPS_REQUEST',
  GET_FOLLOWUPS_SUCCESS = '@followupOnlineSearch/GET_FOLLOWUPS_SUCCESS',
  GET_FOLLOWUPS_FAILURE = '@followupOnlineSearch/GET_FOLLOWUPS_FAILURE',
  SET_FOLLOWUPS_REQUEST = '@followupOnlineSearch/SET_FOLLOWUPS_REQUEST',
  SET_FOLLOWUPS_SUCCESS = '@followupOnlineSearch/SET_FOLLOWUPS_SUCCESS',
  SET_FOLLOWUPS_FAILURE = '@followupOnlineSearch/SET_FOLLOWUPS_FAILURE',
  UPDATE_STORE_FIELDS = '@followupOnlineSearch/UPDATE_STORE_FIELDS',
}

export interface PublicBodyTypes {
  id: number;
  nome: string;
}

export interface FollowupData {
  data_fonte: string;
  edital: string;
  bidding_id: number;
  id: number;
  objeto: string;
  orgao_cidade: string;
  orgao_estado: string;
  processo: string;
  sintese: string;
  licitacao_fonte_id: number;
  followup_id: number;
  public_body: PublicBodyTypes;
}

export interface FollowupsTypes {
  followup_list: Array<FollowupData>;
  total_entries: number;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface FollowupState {
  readonly followups: FollowupsTypes;
  readonly request: RequestState;
}
